export const isLaptop = () => window.screen.width < 1537;
